export default __webpack_public_path__ + "static/media/trybudtender-logo.8f14432d.png";